import p5 from "p5";
import Particle from "./particle";

let magnitude = 2;
let pointSize = 10;
let maxPointSize = 8;

//color backgroundColor = #14141A;
// let backgroundColor = p5.color("#000000");

let oscillationScalar = 12;

class ParticleSystem {

    constructor(w, h, sketch) {

        // this.pointColor = p5.color(200, 0, 90);

        this.sketch = sketch;

        this.particles = [];

        let xIncrement = maxPointSize + 1; // 15
        let yIncrement = maxPointSize + 1; // 15

        xIncrement = maxPointSize * 2;
        yIncrement = maxPointSize * 2;

        let xPositionsLength = Math.floor((w + 10 * xIncrement) / xIncrement);
        let yPositionsLength = Math.floor((h + 10 * yIncrement) / yIncrement);


        let i = 0;
        for (let xi = 0; xi < xPositionsLength; xi++) {

            for (let yi = 0; yi < yPositionsLength; yi++) {

                // Offset position so have 5 extra circles on left and right sides
                let px = (xi - 5) * xIncrement;
                let py = (yi - 5) * yIncrement;

                let p = new Particle(px, py, i, this.sketch);
                this.particles.push(p);

                i += 1;
            }
        }
    }

    reset() {

        for (let i = 0; i < this.particles.length; i++) {

            // console.log("test", i);
            let p = this.particles[i];
            //p.update();
            p.reset();
        }

    }

    systemParticles() {

        return this.particles;

    }

    render() {


        for (let i = 0; i < this.particles.length; i++) {

            // console.log("test", i);
            let p = this.particles[i];
            //p.update();
            p.render();
        }
    }
}

export default ParticleSystem;